// @ts-ignore
export const subscribe = async ({ commit }) => {
  // tslint:disable-next-line
  console.log('Subscribe');
};

// @ts-ignore
export const removeLoader = async ({ commit }) => {
  commit('removeLoader');
};

// @ts-ignore
export const start = async ({ commit }) => {
  commit('addLoader');
};

// @ts-ignore
export const stop = async ({ commit }) => {
  commit('removeLoader');
};
